// picks the parameters from url and passes to component.

import _get from 'lodash/get';
import { withProps } from 'recompose';
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
var mapRouteParamsToProps = function mapRouteParamsToProps(props) {
  var routeParams = _get(props, 'match.params', EMPTY_OBJECT);
  return routeParams;
};
var withRouteParams = withProps(mapRouteParamsToProps);
export default withRouteParams;